// extracted by mini-css-extract-plugin
export default {"additional_item":"xE","info_wrapper":"yE","addition_item_img_wrapper":"zE","title":"AE","quantity":"BE","flavors":"CE","old_price":"EE","discount":"FE","button_wrapper":"GE"};
    if(module.hot) {
      // 1714422956218
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  